import React, { useEffect, useState } from "react";
import { getMaterials, deleteMaterial } from "../../../api/materialService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../../utils/errorHandler"

export default function MaterialList() {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const navigate = useNavigate();

  const fetchMaterials = async () => {
    try {
      setLoading(true);

      const response = await getMaterials({ search, sort });
      setMaterials(response?.data || response?.materials || []);
    } catch (error) {
      console.error("Error fetching materials:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, [search, sort]);

  const handleDelete = async (id) => {
    try {
      await deleteMaterial(id);

      fetchMaterials();
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4 np-material-options-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Material List</h5>
        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "220px" }}
            placeholder="Search material..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/material/add")}
          >
            <FaPlus />
            Add Material
          </button>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="text-center py-3">Loading...</div>
          ) : (
            <table className="table table-bordered table-hover">
            <thead className="bg-white">
  <tr>
    <th className="text-dark fw-bold">#</th>
    <th className="text-dark fw-bold">Material Name</th>
    <th className="text-dark fw-bold">Material Value</th>
    <th className="text-dark fw-bold">Status</th>
    <th className="text-dark fw-bold text-center">Actions</th>
  </tr>
</thead>
              <tbody>
                {materials.length > 0 ? (
                  materials.map((material, index) => (
                    <tr key={material._id}>
                      <td>{index + 1}</td>

                      <td>{material.name}</td>

                      <td>{material.value}</td>

                      <td>
                        <span
                          className={`badge ${
                            material.status === "ACTIVE"
                              ? "bg-success"
                              : "bg-danger"
                          }`}
                        >
                          {material.status}
                        </span>
                      </td>
                      <td className="text-center d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-sm np-table-action-btn"
                          onClick={() =>
                            navigate(`/material/view/${material.name}`, {
                              state: { materialId: material._id },
                            })
                          }
                        >
                          <FaEye />
                        </button>

                        <button
                          className="btn btn-sm np-table-action-btn"
                          onClick={() =>
                            navigate(`/material/edit/${material.name}`, {
                              state: { materialId: material._id },
                            })
                          }
                        >
                          <FaEdit />
                        </button>

                        <button
                          className="btn btn-sm np-table-action-btn"
                          onClick={() => handleDelete(material._id)}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No materials found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
